import styled from 'styled-components'
import { breakpoints } from 'globalStyles'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-bottom: 42px;
  margin-top: 24px;
  @media ${breakpoints.xxs} {
    max-width: 319px;
  }
  @media ${breakpoints.tablet} {
    margin-top: 32px;
  }
  @media ${breakpoints.desktop} {
    margin-top: 40px;
  }
`
export const ShipmentDetailsContainer = styled.div`
  position: relative;
  display: flex;
  justify-self: center;
  @media ${breakpoints.phone} {
    max-width: 400px;
    width: 100%;
    padding: 0 16px;
  }
  @media ${breakpoints.tablet} {
    max-width: 612px;
    width: 100%;
  }
  @media ${breakpoints.desktop} {
    max-width: 1024px;
    width: 100%;
  }
`

export const ShippingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 580px;
  gap: 24px;
  @media ${breakpoints.tablet} {
    max-width: 612px;
  }
  @media ${breakpoints.desktop} {
    max-width: 1024px;
  }
`
export const ShippingInfoContainer = styled.div`
  display: grid;
  grid-gap: 24px;
  width: 100%;
  @media ${breakpoints.xxs} {
    max-width: 315px;
  }
`
export const StickyContainer = styled.div`
  display: flex;
  position: absolute;
  align-items: flex-end;
  top: 167px;
  right: 0px;
  height: 100%;
`

export const Sticky = styled.div`
  position: sticky;
  bottom: 300px;
`
